// src/pages/ContactForm.jsx
import { Link } from 'react-router-dom';
import { InlineWidget } from 'react-calendly';
import cognitoIcon from '../../Assets/cognito-icon.png';

const ContactForm = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 to-white">
      {/* Main Content */}
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center mb-10">
          <Link to="/" className="inline-flex items-center space-x-3 no-underline mb-8">
            <img src={cognitoIcon} alt="Jobrise Logo" className="w-10 h-10" />
            <span className="text-2xl font-bold text-slate-900">Jobrise</span>
          </Link>
          <h1 className="text-4xl font-extrabold text-slate-900">Demandez une démo</h1>
        </div>

        <InlineWidget
          url="https://calendly.com/florian-jobrise/30min"
          styles={{ height: '700px' }}
        />
      </div>
    </div>
  );
};

export default ContactForm;
